export default __webpack_public_path__ + "static/media/homedialysis02.1fce7909.svg";